import "./Scorm.scss";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import images from "../../../ressources/images";
import { useHistory, useRouteMatch } from "react-router-dom";
import consola from "consola";
import {store} from "../../../store/configureStore";

const Scorm = ({ scorm_path, title }) => {
  const token = store.getState().auth.access_token
  const { i18n, t } = useTranslation();
  const router = useHistory();
  const match = useRouteMatch();

  let url = scorm_path;

  if (url.includes("?")) {
    url += "&access_token=" + token;
  } else {
    url += "?access_token=" + token;
  }

  url += "&locale=" + i18n.language;

  const handleMessage = (event) => {
    if (event.origin === window.location.origin) {
      return;
    }

    consola.info("Received message from iframe: ", event.data);

    if (event.data === "completed") {
      consola.success("Scorm is completed, now redirecting to result page");

      const url = match.url.replace("/scorm", "");
      router.push(url + "/result");
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage, false);

    return () => {
      window.removeEventListener("message", handleMessage, false);
    };
  }, []);

  const handleClose = () => {
    const id = match.params.id;
    router.replace("/formations/" + id);
  };

  return (
    <div className="scorm_wrapper">
      <div className="scorm__header">
        <button className="close_quizz" onClick={handleClose}>
          <img src={images.closeCross} alt="" />
        </button>
        <p>{title}</p>
      </div>
      <object data={url} width="100%" height="100%">
        Error: learning could not be displayed.
        {t("error_learning_default")}
      </object>
    </div>
  );
};

export default Scorm;
